import { HttpPostTransport } from "@lorefnon/ts-json-rpc/lib/client";
export class AGTransport extends HttpPostTransport {
    getUrl(_method, _params, meta) {
        return `${this.options.url}/rpc/${meta.name}`;
    }
}
export class AGGWTransport extends HttpPostTransport {
    getUrl(_method, _params, meta) {
        return `${this.options.url}/gateway/rpc/${meta.name}`;
    }
}
//# sourceMappingURL=clients.js.map